import { render, staticRenderFns } from "./address-bundle-table.vue?vue&type=template&id=2432485c"
import script from "./address-bundle-table.vue?vue&type=script&lang=js"
export * from "./address-bundle-table.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports